export const environment = {
  production: false,
  authTokenKey: 'storeLTGOSession',
  tema: 'tema',
  apiUrl: "https://api.littletreesgo.com/api/v1"
  // webUrl: "https://api.littletreesgo.com"
  // webUrl: "http://localhost:8000",
  // apiUrl: "http://localhost:8000/api/v1"
};
